module.exports = __webpack_public_path__ + "img/168-Siena PR.jpg";